export default "__VITE_ASSET__b2ef82c6__"